import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en.json';

// Default language is English, Another language is not supported yet.
const DEFAULT_LANGUAGE = 'en';
i18n.use(initReactI18next).init({
  resources: {
    en,
  },
  lng: DEFAULT_LANGUAGE,
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: {
    escapeValue: false,
  },
});
